import React, { useMemo } from "react"
import ActivityBase from "@/components/activities/base"
import OwnerLabel from "@/components/activities/owner_label"
import i18n from "@/i18n"
import Changes from "@/components/activities/changes"
import { getBookingPolicyTileTitle, type BookingPolicyTileKind } from "@/shared/booking_policy"

interface UpdatedReservationConfigurationProps {
  activity: any
  className?: string
}

const UpdatedReservationConfiguration = ({ activity, className }: UpdatedReservationConfigurationProps) => {
  const LABELS = {
    maxReservationTime: i18n.t("app.activities.venue.reservation_config.max_reservation_time"),
    minReservationTime: i18n.t("app.activities.venue.reservation_config.min_reservation_time"),
    reservationBuffer: i18n.t("app.activities.venue.reservation_config.reservation_buffer"),
    maxAdvanceBookingTime: i18n.t("app.activities.venue.reservation_config.max_advance_booking_time"),
    minAdvanceBookingTime: i18n.t("app.activities.venue.reservation_config.min_advance_booking_time"),
    largeGroupThreshold: i18n.t("app.activities.venue.reservation_config.large_group_threshold"),
    noshowAutoCancelAfter: i18n.t("app.activities.venue.reservation_config.noshow_auto_cancel_after"),
    cancellationDeadline: i18n.t("app.activities.venue.reservation_config.cancellation_deadline"),
    bookingPolicyTiles: i18n.t("app.activities.venue.reservation_config.booking_policy_tiles"),
  }

  const formatters = useMemo(() => {
    return {
      maxReservationTime: (value) =>
        value != null ? i18n.t("app.activities.venue.reservation_config.duration_minutes", { count: value }) : "",
      minReservationTime: (value) =>
        value != null ? i18n.t("app.activities.venue.reservation_config.duration_minutes", { count: value }) : "",
      reservationBuffer: (value) =>
        value != null ? i18n.t("app.activities.venue.reservation_config.duration_minutes", { count: value }) : "",
      maxAdvanceBookingTime: (value) =>
        value != null ? i18n.t("app.activities.venue.reservation_config.duration_minutes", { count: value }) : "",
      minAdvanceBookingTime: (value) =>
        value != null ? i18n.t("app.activities.venue.reservation_config.duration_minutes", { count: value }) : "",
      largeGroupThreshold: (value) =>
        value != null ? i18n.t("app.activities.venue.reservation_config.people_count", { count: value }) : "",
      noshowAutoCancelAfter: (value) =>
        value != null ? i18n.t("app.activities.venue.reservation_config.duration_minutes", { count: value }) : "",
      cancellationDeadline: (value) =>
        value != null ? i18n.t("app.activities.venue.reservation_config.duration_minutes", { count: value }) : "",
      bookingPolicyTiles: (value) =>
        Array.isArray(value)
          ? value.map((kind) => getBookingPolicyTileTitle(kind as BookingPolicyTileKind)).join(", ")
          : "",
    }
  }, [])

  return (
    <ActivityBase
      data-testid="panel-activity-venue-updated-config"
      activityKey={activity.key}
      text={
        <>
          {i18n.react("app.activities.venue.updated_reservation_configuration.description", {
            owner: <OwnerLabel owner={activity.owner} />,
          })}
          <Changes changes={activity.parameters.changes} labels={LABELS} formatters={formatters} />
        </>
      }
      createdAt={activity.createdAt}
      className={className}
    />
  )
}

export default UpdatedReservationConfiguration
